import React from "react";
import { useTranslation } from "react-i18next";
import { useDashboardContext } from "../../context/customhook/dashboardHook";
import RatingItem from "./RatingItem";

export default function RatingList() {
  const { t } = useTranslation();
  const {dashboardStates}  = useDashboardContext();

  return (
    <div>
      {dashboardStates?.ratingdata &&
        dashboardStates.ratingdata.map((item) => {
          return (
            <RatingItem
              key={item.id}
              ratingtext={t(item.id)}
              ratingId={item.id}
              isSelected={item.isSelected}
            />
          );
        })}
    </div>
  );
}
